import React from 'react';

const SubscriptionPlans = () => {
  return (
    <svg
      className="icon htmlIcon customIcon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 60"
      x="0px"
      y="0px"
      fill="currentColor"
    >
      <g>
        <path d="M28,38H20a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z" />
        <path d="M18,22a1,1,0,0,1-2,0A1,1,0,0,1,18,22Z" />
        <path d="M18,26a1,1,0,0,1-2,0A1,1,0,0,1,18,26Z" />
        <path d="M18,30a1,1,0,0,1-2,0A1,1,0,0,1,18,30Z" />
        <path d="M6,25a1,1,0,0,1-2,0A1,1,0,0,1,6,25Z" />
        <path d="M6,29a1,1,0,0,1-2,0A1,1,0,0,1,6,29Z" />
        <path d="M6,33a1,1,0,0,1-2,0A1,1,0,0,1,6,33Z" />
        <path d="M31,23H21a1,1,0,0,1,0-2H31A1,1,0,0,1,31,23Z" />
        <path d="M31,27H21a1,1,0,0,1,0-2H31A1,1,0,0,1,31,27Z" />
        <path d="M31,31H21a1,1,0,0,1,0-2H31A1,1,0,0,1,31,31Z" />
        <rect x="16" y="10" width="16" height="2" rx="1" />
        <rect x="35" y="13" width="9" height="2" rx="1" />
        <rect x="4" y="13" width="9" height="2" rx="1" />
        <path d="M45,8H37a3,3,0,0,0-3-3H14a3,3,0,0,0-3,3H3a3,3,0,0,0-3,3V37a3,3,0,0,0,3,3h8a3,3,0,0,0,3,3H34a3,3,0,0,0,3-3h8a3,3,0,0,0,3-3V11A3,3,0,0,0,45,8ZM3,38a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1h8V24H9a1,1,0,0,0,0,2h2v2H9a1,1,0,0,0,0,2h2v2H9a1,1,0,0,0,0,2h2v4Zm32,2a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V8a1,1,0,0,1,1-1H34a1,1,0,0,1,1,1Zm11-3a1,1,0,0,1-1,1H37V34h6a1,1,0,0,0,0-2H37V30h6a1,1,0,0,0,0-2H37V26h6a1,1,0,0,0,0-2H37V10h8a1,1,0,0,1,1,1Z" />
      </g>
    </svg>
  );
};

export default SubscriptionPlans;
